interface Props {
  size?: number;
}

export default function StampSpinner({ size = 96 }: Props) {
  return (
    <div
      role="status"
      aria-label="loading"
      className="relative inline-block"
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 100 100" className="block h-full w-full" fill="none">
        <g
          style={{
            transformOrigin: '50px 50px',
            animation: 'stampOrbit 7s linear infinite',
          }}
        >
          <circle
            cx="50"
            cy="50"
            r="46"
            stroke="var(--ink)"
            strokeOpacity="0.45"
            strokeWidth="3"
            strokeDasharray="5 5"
            strokeLinecap="round"
          />
          <circle cx="50" cy="4" r="3.5" fill="var(--ink)" opacity="0.7" />
        </g>

        <g
          style={{
            transformOrigin: '50px 50px',
            animation: 'stampSpin 1.05s cubic-bezier(0.45, 0, 0.55, 1) infinite',
          }}
        >
          <circle
            cx="50"
            cy="50"
            r="34"
            stroke="var(--hot-pink)"
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray="78 135"
          />
        </g>

        <g
          style={{
            transformOrigin: '50px 50px',
            animation: 'stampSpinReverse 1.6s cubic-bezier(0.45, 0, 0.55, 1) infinite',
          }}
        >
          <circle
            cx="50"
            cy="50"
            r="20"
            stroke="var(--ink)"
            strokeOpacity="0.9"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="32 80"
          />
        </g>

        <circle cx="50" cy="50" r="6" fill="var(--hot-pink)">
          <animate attributeName="r" values="6;3;6" dur="1.05s" repeatCount="indefinite" />
          <animate
            attributeName="opacity"
            values="1;0.55;1"
            dur="1.05s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
      <style>{`
        @keyframes stampSpin { to { transform: rotate(360deg); } }
        @keyframes stampSpinReverse { to { transform: rotate(-360deg); } }
        @keyframes stampOrbit { to { transform: rotate(360deg); } }
        @media (prefers-reduced-motion: reduce) {
          [aria-label="loading"] g { animation: none !important; }
          [aria-label="loading"] animate { display: none; }
        }
      `}</style>
    </div>
  );
}
